'use strict';

export function  TimerSet() {
  $(".js-timer").each(function(index, target) {
    var startDate = $(this).attr("data-start-date");
    var endDate = $(this).attr("data-end-date");
    var nowDate = new Date();

    if (startDate) {
      startDate = new Date(startDate);
    }
    else {
      startDate = nowDate;
    }
    if (endDate) {
      endDate = new Date(endDate);
    }

    if (startDate <= nowDate && (!endDate || nowDate <= endDate)) {
      $(this).show();
    }
    else {
      $(this).hide();
    }
  });

  // if (new Date('2023/12/15 20:00:00') <= new Date()) {
  //   document.querySelector('meta[name="description"]').setAttribute("content", "SIRUP が自身初のホストをつとめる、新音楽イベント『Grooving Night』が、2024年3月19日(火)大阪・Zepp Namba で開催！読売テレビとタッグを組み今までにない新たな企画がスタート。");
  //   document.querySelector('meta[property="og:description"]').setAttribute("content", "SIRUP が自身初のホストをつとめる、新音楽イベント『Grooving Night』が、2024年3月19日(火)大阪・Zepp Namba で開催！読売テレビとタッグを組み今までにない新たな企画がスタート。");
  //   document.querySelector('meta[property="og:image"]').setAttribute("content", "https://groovingnight.jp/assets/images/ogp-img-03.jpg");
  //   document.querySelector('meta[name="twitter:image"]').setAttribute("content", "https://groovingnight.jp/assets/images/ogp-img-03.jpg");
  // }
}
